import { render, staticRenderFns } from "./TermsAcknowledgePrint.vue?vue&type=template&id=2a5cdfdd&"
import script from "./TermsAcknowledgePrint.vue?vue&type=script&lang=js&"
export * from "./TermsAcknowledgePrint.vue?vue&type=script&lang=js&"
import style0 from "./TermsAcknowledgePrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports